/* ============================================================
   CLASE 33 — Independencia JS
   Scroll reveals + Timeline Intersection Observer
   ============================================================ */

(function () {
  'use strict';

  /* ── Scroll reveals ────────────────────────────────────────── */
  function initReveal() {
    var targets = document.querySelectorAll('.ind-reveal');
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Timeline hitos animados ───────────────────────────────── */
  function initTimeline() {
    var hitos = document.querySelectorAll('.ind-hito');
    if (!hitos.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }
    );

    hitos.forEach(function (el, i) {
      el.style.transitionDelay = (i * 0.12) + 's';
      observer.observe(el);
    });
  }

  /* ── Init ──────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initTimeline();
    });
  } else {
    initReveal();
    initTimeline();
  }
})();
